module.exports = __webpack_public_path__ + "static/DHCM3-5be4ba9e07479242cde3a828d9ea3f83.png";